import axios from "axios";
import qs from "qs";
const api = "/creditapi";

/**
 * 获取查询日志
 * @param pageNum
 * @param pageSize
 * @returns {AxiosPromise<any>}
 */
export function getXzxkList({   ztmc,
                                type,
                                xkjg,
                                startTime,
                                endTime,
                                pageNum,
                                status }) {
    return axios.get(api + "/licence/getPageList", {
        params: {
            ztmc,
            type,
            xkjg,
            startTime,
            endTime,
            pageNum,
            status
        }
    });
}
export function findONE( id ) {
    return axios.get(api + "/licence/findOne", {
        params: {id}
    });
}

/**
 * 新增行政许可
 * @param name
 * @param uscc
 * @returns {AxiosPromise<any>}
 */
export function addXzxk({   xkmc,wsh,xklb,otherDesc,zsmc,
                            xkbh,xknr,jdrq,dStatus,yxqz,
                            yxqzh,xkjg,xk_USCC,LYDW,LY_USCC,
                            bz,xzxdrmc,xzxdrlb,USCC,fddbr,
                            fddbrlx,fddbrzjh,zjlx,zjhm,status,
                            zrrOtherLx, fddbrOtherLx,xzxkGsdj }) {
    return axios.post(
        api + "/licence/add",
        qs.stringify({
            xkmc,wsh,xklb,otherDesc,zsmc,
            xkbh,xknr,jdrq,dStatus,yxqz,
            yxqzh,xkjg,xk_USCC,LYDW,LY_USCC,
            bz,xzxdrmc,xzxdrlb,USCC,fddbr,
            fddbrlx,fddbrzjh,zjlx,zjhm,status,
            zrrOtherLx, fddbrOtherLx,xzxkGsdj
        })
    );
}

/**
 * 修改行行政许可
 * @returns {AxiosPromise<any>}
 */
export function updateXzxk({   xkmc,wsh,xklb,otherDesc,zsmc,
                               xkbh,xknr,jdrq,dStatus,yxqz,
                               yxqzh,xkjg,xk_USCC,LYDW,LY_USCC,
                               bz,xzxdrmc,xzxdrlb,USCC,fddbr,
                               fddbrlx,fddbrzjh,zjlx,zjhm,id,status,stype,
                               zrrOtherLx,fddbrOtherLx,xzxkGsdj,unId }) {
    return axios.post(
        api + "/licence/edit",
        qs.stringify({
            xkmc,wsh,xklb,otherDesc,zsmc,
            xkbh,xknr,jdrq,dStatus,yxqz,
            yxqzh,xkjg,xk_USCC,LYDW,LY_USCC,
            bz,xzxdrmc,xzxdrlb,USCC,fddbr,
            fddbrlx,fddbrzjh,zjlx,zjhm,id,status,stype,
            zrrOtherLx,fddbrOtherLx,xzxkGsdj,unId
        })
    );
}


export function deleteXzxkById(id) {
    return axios.get(api + "/licence/delete", {
        params: {id}
    });
}

export function getSource() {
    return axios.get(api + "/licence/getSource", {
        params: {}
    });
}


/**
 * 上传文件
 * @param {} file
 */
export function batchAdd(formData) {
    return axios({
        url: api + "/licence/batchAdd",
        method: "post",
        data: formData,
        headers: {"Content-Type": "application/x-www-form-urlencoded"}
    });
}

export function getLogList({sTime, eTime, pageNum, pageSize}){
    return axios.get(api + "/licence/getLogList",{
        params: {sTime, eTime, pageNum, pageSize}
    })
}

export function downloadDataExcel(){
    return axios.get(api + "/licence/downloadDataExcel",{
        params: {}
    })
}

/**
 * 获取错误详情
 * @param pageNum
 * @param pageSize
 * @returns {AxiosPromise<any>}
 */
export function getErrorList({   id,
                                 current}) {
    return axios.get(api + "/licence/getErrorPage", {
        params: {
            id,
            current
        }
    });
}
